import React from 'react';
import { Container } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ActivitiesTable from './components/ActivitiesTable'

const BasicTables = (props) => (
    <Container>
        <ActivitiesTable {...props} />
    </Container>
);

BasicTables.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('common')(BasicTables);

